export let ProfessionalSituation = /*#__PURE__*/function (ProfessionalSituation) {
  ProfessionalSituation["Jobseeker"] = "jobseeker";
  ProfessionalSituation["CpasJobseeker"] = "cpas_jobseeker";
  return ProfessionalSituation;
}({});